export default {
    countrySelectorLabel: 'Country code',
    countrySelectorError: 'Choose country',
    phoneNumberLabel: 'Phone number',
    example: 'Example:'
};
